import { IAlarmFilter } from '@interfaces/alarms/alarm';
import { IOrganizationId } from '@interfaces/common/common';

import useQueryNetworkElementsEventTypes from './useQueryNetworkElementsEventTypes';
import useQueryNetworkElementsNames from './useQueryNetworkElementsNames';
import useQueryNetworkElementsVendors from './useQueryNetworkElementsVendors';

interface IUseNetworkElementsConnectionLogsFilters {
	connectionLogsFiltersList: IAlarmFilter[];
	isLoadingConnectionLogsFilters: boolean;
}

export const useNetworkElementsConnectionLogsFilters = (
	params: Partial<IOrganizationId>,
): IUseNetworkElementsConnectionLogsFilters => {
	const { vendorOptions, isLoadingVendorOptions } = useQueryNetworkElementsVendors(params);
	const { namesOptions, isLoadingNamesOptions } = useQueryNetworkElementsNames(params);
	const { eventTypesOptions, isLoadingEventTypesOptions } = useQueryNetworkElementsEventTypes(params);

	const connectionLogsFiltersList = [
		{
			name: 'eventType',
			placeholder: 'Event Type',
			data: eventTypesOptions,
		},
		{
			name: 'networkElementName',
			placeholder: 'Name',
			data: namesOptions,
		},
		{
			name: 'vendor',
			placeholder: 'Vendor',
			data: vendorOptions,
		},
	];

	return {
		connectionLogsFiltersList,
		isLoadingConnectionLogsFilters: isLoadingNamesOptions ||
			isLoadingVendorOptions ||
			isLoadingEventTypesOptions,
	};
};
